@if (canPage()) {
  <lib-timeline-nav
    unit="month"
    [title]="navTitle()"
    [atFirst]="atFirst()"
    [atLast]="atLast()"
    (today)="goToday()"
    (step)="step($event)"
  />
}
@if (dotsOnly()) {
  <div
    class="dots-grid"
    role="group"
    [attr.aria-label]="label()"
  >
    @for (weekday of weekdays; track weekday) {
      <div
        class="weekday"
        aria-hidden="true"
        >{{ weekday.charAt(0) }}</div
      >
    }
    @for (week of weeks(); track week.start) {
      @for (day of week.days; track day.day) {
        <button
          type="button"
          class="dot-day"
          [class.out]="!day.inMonth"
          [class.off]="day.outOfRange"
          [class.is-selected]="selectedDay() === day.day"
          [attr.aria-label]="day.dayLabel"
          [attr.aria-pressed]="selectedDay() === day.day"
          [disabled]="day.outOfRange"
          (click)="daySelected.emit(day.day)"
        >
          <span
            class="num"
            [class.today]="day.today"
            aria-hidden="true"
            >{{ day.date }}</span
          >
          <span
            class="dots"
            aria-hidden="true"
          >
            @for (color of day.dots; track $index) {
              <span
                class="dot"
                [style.background]="color"
              ></span>
            }
          </span>
        </button>
      }
    }
  </div>
} @else {
  <div class="scroll">
    <div
      class="calendar"
      role="region"
      [attr.aria-label]="label()"
    >
      <div
        class="weekdays"
        aria-hidden="true"
      >
        @for (weekday of weekdays; track weekday) {
          <div class="weekday">{{ weekday }}</div>
        }
      </div>
      @for (week of weeks(); track week.start) {
        <div
          class="week"
          [style.grid-template-rows]="week.gridRows"
        >
          @for (day of week.days; track day.day) {
            <div
              class="bg"
              [class.out]="!day.inMonth"
              [class.off]="day.outOfRange"
              [class.today]="day.today"
              [style.grid-column]="day.column"
              [style.grid-row]="'1 / ' + (week.chipRow + 1)"
            ></div>
            <span
              class="num"
              [class.out]="!day.inMonth"
              [class.off]="day.outOfRange"
              [class.today]="day.today"
              [style.grid-column]="day.column"
            >
              <span aria-hidden="true">{{ day.date }}</span
              ><span class="cdk-visually-hidden">{{ day.dayLabel }}</span>
            </span>
          }
          @for (bar of week.bars; track bar.entry.id) {
            <lib-timeline-bar
              [bar]="bar"
              [selected]="selectedId() === bar.entry.id"
              [style.grid-column]="bar.firstColumn + ' / ' + (bar.lastColumn + 1)"
              [style.grid-row]="bar.lane + 2"
              (selectEntry)="entrySelected.emit($event)"
            />
          }
          @for (day of week.days; track day.day) {
            @if (day.chips.length || day.more) {
              <div
                class="chips"
                [style.grid-column]="day.column"
                [style.grid-row]="week.chipRow"
              >
                @for (entry of day.chips; track entry.id) {
                  <lib-timeline-chip
                    [entry]="entry"
                    [selected]="selectedId() === entry.id"
                    (selectEntry)="entrySelected.emit($event)"
                  />
                }
                @if (day.more) {
                  <button
                    type="button"
                    class="more"
                    (click)="daySelected.emit(day.day)"
                    >+{{ day.more }} more</button
                  >
                }
              </div>
            }
          }
        </div>
      }
    </div>
  </div>
}
